export const getContractId = (flight, selectedFare) =>
  selectedFare?.ContractId ?? flight?.ContractId ?? flight?.Id ?? null;

export const buildSellPayload = (flight, apiToken, agencyKey, bookingKey, returnFlight) => {
  const onwardId = getContractId(flight);
  const returnId = returnFlight ? getContractId(returnFlight) : null;

  return {
    APIToken:   apiToken,
    AgencyKey:  "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
    BookingKey: bookingKey || "",
    ContractId: onwardId,
    // ⚠️ Field ka naam API doc se confirm karo (ReturnContractId / ContractIds ...)
    ...(returnId !== null && { ReturnContractId: returnId }),
    IsB2B: false,
  };
};

export const sellFlight = async (flight, apiToken, agencyKey, bookingKey, returnFlight) => {
  const baseURL = process.env.REACT_APP_FLIGHTS_API_URL;
  if (!baseURL) { console.error("API URL missing"); return null; }

  const payload = buildSellPayload(flight, apiToken, agencyKey, bookingKey, returnFlight);
  console.log("Sell Request Payload:", payload);

  const response = await fetch(`${baseURL}/Trip/Sell`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return response.json();
};